<template>
    <el-container direction="vertical" class="card" v-loading="loading">
        <el-row class="card-header">
            <el-col :span="16">
                <div class="employer-id grey">
                    ID {{ lead.id }} ({{ lead.created_at }})
                </div>
                <div class="page-title bold fnt-lg dark text-left">
                    {{ leadName }}
                </div>
                <div v-if="lead.duplicated_leads[0]">
                    Дубликаты Лидов:
                </div>
                <div v-for="duplicatedLead in lead.duplicated_leads" :key="duplicatedLead.id" class="text-left link" @click="goLead(duplicatedLead.id)">
                    {{ duplicatedLead.id }}, {{ duplicatedLead.title }},
                    обращение в офис {{ getOfficeNameById(duplicatedLead.office_id) }} {{ duplicatedLead.created_at }},
                    <span :class="{ red: duplicatedLead.status_id === 3 , green: duplicatedLead.status_id === 2 }">
                        {{ getStatusNameById(duplicatedLead.status_id) }}
                        <span v-if="duplicatedLead.status_id === 3 && duplicatedLead.refuse_reason">
                            ({{ duplicatedLead.refuse_reason.reference_refuse_reason.name }})
                        </span>
                        <span v-if="duplicatedLead.status_id === 2">
                            ({{ duplicatedLead.deal.status.name }})
                        </span>
                    </span>
                </div>
            </el-col>
            <el-col :span="8" class="actions">
                <span class="action-title action-edit" @click="edit" v-if="canEdit">
                    Редактировать
                </span>
                <span class="action-title action-close" @click="close">
                    Закрыть
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="9" justify="start" class="pl15">
                <div class="card-general card-view">
                    <el-row class="mb10">
                        <el-col :span="4">
                            <span class="grey">
                                Статус:
                            </span>
                        </el-col>
                        <el-col :span="19">
                            <span v-html="statusName"></span>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="4">
                            <span class="grey">
                                Канал связи:
                            </span>
                        </el-col>
                        <el-col :span="19">
                            {{ linkName }}
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="4">
                            <span class="grey">
                                Название:
                            </span>
                        </el-col>
                        <el-col :span="19">
                            {{ lead.title }}
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="4">
                            <span class="grey">
                                Адрес:
                            </span>
                        </el-col>
                        <el-col :span="19">
                            {{ lead.address }}
                        </el-col>
                    </el-row>
                    <el-row class="mb10" v-if="issetDeal">
                        <el-col :span="4">
                            <span class="grey">
                                Сделка:
                            </span>
                        </el-col>
                        <el-col :span="19">
                            <div class="link" @click="goDeal(lead.deal.id)">
                                {{ lead.deal.id }}
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="card-general card-view mt10 list">
                    <el-row v-loading="loadingContact">
                        <el-col :span="24">
                            <el-row class="wauto">
                                <el-col :span="3" class="label">
                                    <span class="grey">
                                        Контакт:
                                    </span>
                                </el-col>
                                <el-col :span="21">
                                    <div class="link" @click="goContact(lead.contact.id)">
                                        {{ contactName }}
                                    </div>
                                </el-col>
                            </el-row>
                            <template v-if="contactName">
                                <template v-for="phone in lead.contact.contact_phones">
                                    <el-row :key="phone.id" class="wauto">
                                        <el-col :span="3" class="label">
                                            <span class="grey">
                                                Телефон:
                                            </span>
                                        </el-col>
                                        <el-col :span="21">
                                            {{ phone.phone }}
                                            <span class="pt5 pl5 pointer" @click="calltoPhone(phone.phone)">
                                                <font-awesome-icon icon="phone" class="orange" title="Позвонить" />
                                            </span>
                                        </el-col>
                                    </el-row>
                                </template>
                                <el-row class="wauto">
                                    <el-col :span="3" class="label">
                                        <span class="grey">
                                            E-mail:
                                        </span>
                                    </el-col>
                                    <el-col :span="21">
                                        {{ lead.contact.email }}
                                    </el-col>
                                </el-row>
                            </template>
                        </el-col>
                    </el-row>
                </div>
                <div class="card-general card-view mt10">
                    <el-row class="mb10">
                        <el-col :span="5">
                            <span class="grey">
                                Офис:
                            </span>
                        </el-col>
                        <el-col :span="19">
                            {{ officeName }}
                        </el-col>
                    </el-row>
                    <el-row class="mb10 wauto">
                        <el-col :span="5" class="label">
                            <span class="grey">
                                Ответственный:
                            </span>
                        </el-col>
                        <el-col :span="15">
                            <template v-if="issetResponsibleUser">
                                <div class="link" @click="goEmployer(lead.responsible_user.id)">
                                    {{ responsibleName }}
                                </div>
                            </template>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="5">
                            <span class="grey">
                                Roistat:
                            </span>
                        </el-col>
                        <el-col :span="15">
                            <span>{{ getRoistat }}</span>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
            <el-col :span="15" :class="['ml15', { 'darken-lead-column': isDarkenColumn }]" style="width: 61%;">
                <tasks
                    :entity-id="this.id"
                    entity-type="lead"
                    @changeVisibility="darkenColumn"
                />
                <template v-if="loadEvent">
                    <events
                        entity-type="lead"
                        :entity-id="+id"
                        :entity="lead"
                        @changeVisibility="darkenColumn"
                        v-if="this.id"
                    />
                </template>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faPhone } from '@fortawesome/free-solid-svg-icons';
import Events from '@/components/events/Events';
import Tasks from '@/components/Tasks';
import localReferences from '@/helpers/localReferences';
import '@/assets/styles/card.scss';

library.add(faCheck);
library.add(faPhone);

export default {
    name: 'LeadCard',
    props: {
        id: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            loading: true,
            loadingContact: false,
            lead: {},
            statusNew: 1,
            statusTarget: 2,
            statusNotTarget: 3,
            isDarkenColumn: false,
            loadEvent: false
        };
    },
    components: {
        Events,
        Tasks
    },
    computed: {
        leadName() {
            let name = '';
            if (this.lead.contact && this.lead.contact.name) {
                name += this.lead.contact.name;
            } else {
                name += 'Нет контакта';
            }
            if (this.lead.link && this.lead.link.name) {
                if (this.lead.link_id === localReferences.referenceLink.link_email) {
                    name += ' - письмо';
                    if (this.lead.contact && this.lead.contact.email) {
                        name += ' - ' + this.lead.contact.email;
                    }
                } else if (
                    this.lead.link_id === localReferences.referenceLink.link_call ||
                    this.lead.link_id === localReferences.referenceLink.link_missed_call
                ) {
                    if (this.lead.contact && this.lead.contact.contact_phones && this.lead.contact.contact_phones.length > 0) {
                        name += ' входящий звонок c ' + this.lead.contact.contact_phones[0].phone;
                    }
                } else {
                    name += ' - ' + this.lead.link.name;
                }
            }

            return name;
        },
        linkName() {
            return this.lead.link ? this.lead.link.name : null;
        },
        statusName() {
            if (!this.lead.status) {
                return;
            }
            let className = 'grey-dark';
            if (this.lead.status.id === this.statusNotTarget) {
                className = 'red';
            } else if (this.lead.status.id === this.statusTarget) {
                className = 'green';
            }
            const status = this.lead.status ? this.lead.status.name : null;
            return '<div class="bold ' + className + '">' + status + '</div>';
        },
        officeName() {
            return this.lead.office ? this.lead.office.name : null;
        },
        issetDeal() {
            return this.lead.deal && this.lead.deal.id > 0;
        },
        responsibleName() {
            return this.lead.responsible_user ? this.lead.responsible_user.full_name : null;
        },
        getRoistat() {
            return this.lead.roistat_visit_id
                ? this.lead.roistat_visit_id
                : this.lead.roistat_marker;
        },
        contactName() {
            return this.lead.contact ? this.lead.contact.name : null;
        },
        companyName() {
            return this.lead.company ? this.lead.company.name : null;
        },
        approvedRoles() {
            console.log(this.$store.getters['references/rolesBySectionLeadByOffices']);
            return this.$store.getters['references/rolesBySectionLead'];
        },
        canEdit() {
            const roles = this.$store.state.auth.roles;
            const intersection = Object.keys(roles).filter(x => this.approvedRoles.includes(x));
            return intersection.length > 0;
        },
        issetCompany() {
            return this.lead.company_id > 0;
        },
        issetContact() {
            return this.lead.contact_id > 0;
        },
        issetResponsibleUser() {
            return this.lead.responsible_user_id > 0;
        }
    },
    beforeMount() {
        this.getLead();
    },
    methods: {
        async getLead() {
            await this.$store.dispatch('leads/getLead', this.id).then(
                response => {
                    if (response.data.data.deal && response.data.data.deal.id) {
                        this.goDeal(response.data.data.deal.id);
                    }
                    this.loading = false;
                    this.loadEvent = true;
                    this.lead = response.data.data;
                },
                error => {
                    console.log(error);
                }
            );
        },
        edit() {
            if (this.canEdit) {
                this.$router.push({ name: 'lead-card', params: { id: '' + this.id } });
            }
        },
        calltoPhone(phone) {
            this.loadingContact = true;
            this.$store.dispatch('voip/callToPhone', { phone: phone }).then(
                response => {
                    console.log('response', response.data.data);
                    this.$message({
                        showClose: true,
                        message: 'Начат звонок на номер ' + phone,
                        type: 'success',
                        duration: 3000,
                        customClass: this.alertClass()
                    });
                    this.errors = {};
                },
                error => {
                    console.log('error', error.response.data);
                    this.$message({
                        showClose: true,
                        message: 'Ошибка при звоноке на номер ' + phone,
                        type: 'error',
                        duration: 1500,
                        customClass: this.alertClass()
                    });
                }
            ).finally(() => { this.loadingContact = false; });
        },
        close() {
            this.$router.go(-1);
        },
        goContact(id) {
            this.$router.push({ name: 'contact-card', params: { id: '' + id } });
        },
        goDeal(id) {
            this.$router.push({ name: 'deal-card', params: { id: '' + id } });
        },
        goCompany(id) {
            this.$router.push({ name: 'company-card', params: { id: '' + id } });
        },
        goEmployer(id) {
            this.$router.push({ name: 'employer-card', params: { id: '' + id } });
        },
        darkenColumn(value) {
            this.isDarkenColumn = value;
        },
        goLead(id) {
            this.id = id;
            this.$router.push({ name: 'lead-card-view', params: { id: '' + id } });
            this.getLead();
        },
        getOfficeNameById(id) {
            if (!id) {
                return 'не указан';
            }
            return this.$store.getters['references/getOfficeNameById'].filter(item => item.id === id)[0].name;
        },
        getStatusNameById(statusId = null) {
            let status = '';
            if (statusId === this.statusNotTarget) {
                status = 'не целевой';
            } else if (statusId === this.statusTarget) {
                status = 'целевой';
            } else if (statusId === this.statusNew) {
                status = 'не обработан';
            }
            return status;
        }
    }
};
</script>
